import { useDispatch, useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { editItemFromTableByID } from "../../../store/slices/customers/customerDetailsPageSlice";
import { getFormatedDate } from "../../../utils/functions/table";
import { useEffect, useMemo, useState } from "react";
import styles from "./customers.module.scss";
import {
  useGetCancelRequestListDataQuery,
  useUpdateCancelRequestListDataMutation,
} from "../../../store/queries/cancellationRequestSurrender";
import {
    deleteItemFromTable,
  updateConfig,
} from "../../../store/slices/CancellationRequestSurrender/cancellationRequestSurrenderSlice.js";
import { Link } from "react-router-dom";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import { toast } from "react-toastify";

const useCancellationRequestSurrender = () => {
  const dispatch = useDispatch();

  const surrenderDetailsPage = useSelector((state) => state.surrenderDetailsPage);

  const cancelRequestPage = useSelector((state) => state.cancellationRequestSurrender);
  const { showEditModal } = useSelector((state) => state.global);
  const [showform, setShowform] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedItemID, setSelectedItemID] = useState("");
  const [isFilterShow, setIsFilterShow] = useState(false);

  let paginationOptions = [
    { label: "10 per page", value: 10 },
    { label: "20 per page", value: 20 },
    { label: "30 per page", value: 30 },
  ];

  useEffect(() => {
    if (surrenderDetailsPage.selectedItemsDetails !== "" && !showform) {
      dispatch(
        updateConfig((state) => {
          state.selectedItemsDetails = "";
        })
      );
    }
    // eslint-disable-next-line
  }, [showform]);

  const [updateCancelRequestFields] = useUpdateCancelRequestListDataMutation();
  const {
    data: cancelRequestList = {},
    isFetching,
    isLoading,
    refetch,
  } = useGetCancelRequestListDataQuery({
    page_size: cancelRequestPage?.currentPageSize,
    page: cancelRequestPage?.currentPage,
    sort_by: cancelRequestPage?.sortBy,
    franchise_id: cancelRequestPage?.franchiseId?.value,
    // is_confirmed: cancelRequestPage.isConfirmedId.value?.toString(),
    sort_order: cancelRequestPage?.sortOrder,
    start_date: cancelRequestPage?.startDate
      ? cancelRequestPage.startDate + " 00:00:00"
      : "",
    end_date: cancelRequestPage?.endDate
      ? cancelRequestPage.endDate + " 00:00:00"
      : "",
    search: cancelRequestPage?.search,
  });



  const hasCreatePermission = useMemo(() => {
    let permission = cancelRequestList?.data?.permission?.filter((p) =>
      Object.keys(p).includes("can_create")
    );

    return permission?.length ?? permission?.[0]?.can_create;
  }, [cancelRequestList]);

  const hasViewPermission = useMemo(() => {
    let permission = cancelRequestList?.data?.permission?.filter((p) =>
      Object.keys(p).includes("can_view")
    );

    return permission?.length ?? permission?.[0]?.can_view;
  }, [cancelRequestList]);

  const hasEditPermission = useMemo(() => {
    let permission = cancelRequestList?.data?.permission?.filter((p) =>
      Object.keys(p).includes("can_edit")
    );

    return permission?.length ?? permission?.[0]?.can_edit;
  }, [cancelRequestList]);

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };

  const handleDateChange = (range) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = getFormatedDate(range.startDate);
        state.endDate = getFormatedDate(range.endDate);
      })
    );
  };

  const handleDelete = async (ids) => {
    setShowDeleteConfirm(true);
    setSelectedItemID(ids);
  };

  const handleDeleteAction = async () => {
    if (selectedItemID && showDeleteConfirm) {
      
      dispatch(deleteItemFromTable(selectedItemID))
        .unwrap()
        .then((result) => {
          if (result.data.data) {
            refetch();
            setSelectedItemID("");
            setShowDeleteConfirm(false);
          }
          toast.success(result.data?.message);
        })
        .catch((err) => {
          setShowDeleteConfirm(false);
          handleUnknownError(setShowDeleteConfirm);
          toast.error(err);
        });
    } else {
      setShowDeleteConfirm(false);
      handleUnknownError(setShowDeleteConfirm);
    }
  };
  const handleSort = (label) => {
    if (cancelRequestPage.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            cancelRequestPage.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleUnknownError = () => {
    alert("Sorry something went wrong!");
  };

  const handleEditAction = (ids) => {
    if (Array.isArray(ids)) {
      dispatch(editItemFromTableByID({ testimonial_id: ids[0] }))
        .unwrap()
        .then((data) => {
          setShowform(true);
        });
    }
  };

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };
  const handleEditClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = true;
      })
    );
  };

  const closeEditModal = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = false;
      })
    );
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      surrender_no: (feild, data) => (
        <p className="pro-mb-0">
          {data.status === "Confirmed" ? (
            <Link to={`detail-surrender/${data["id"]}`} className="link-primary">
              {data[feild]}
            </Link>
          ) : data.status === "Cancellation Requested" ? (
            <Link to={`detail-surrender/${data["id"]}`}>{data[feild]}</Link>
          ) : (
            <Link to={`detail-surrender/${data["id"]}`} className="pro-link-danger">{data[feild]}</Link>
          )}
        </p>
      ),
      id: (feild, data) => (
        <p className="pro-mb-0">
          {data.status === "Confirmed" ? (
            <Link to={`detail-surrender/${data["id"]}`} className="link-primary">
              {data[feild]}
            </Link>
          ) : (
            <Link to={`detail-surrender/${data["id"]}`}>{data[feild]}</Link>
          )}
        </p>
      ),
      status: (feild, data) => (
        <p className={`pro-mb-0 pro-text-center`}>
          {data.status === "Confirmed" ? (
            <span
              className={`${styles.conform_pill} ${styles.green} ${styles.purcahsePill}`}
            >
              {data[feild]}
            </span>
          ) : data.status === "Cancellation Requested" ? (
            <span className={`${styles.conform_pill} ${styles.blue}`}>
              {data[feild]}
            </span>
          ) : (
            <span
              className={`${styles.conform_pill} ${styles.red} ${styles.purcahsePill}`}
            >
              {data[feild]}
            </span>
          )}
        </p>
      ),
      action: (feild, data) => (
        <p className="pro-mb-0 pro-d-flex">
          <button
            onClick={() => {
              handleCancel(data?.id);
            }}
            className="pro-btn pro-btn-primary pro-px-5 pro-py-1"
            disabled={data?.is_confirmed === "Cancelled"}
            title="Approve"
          >
            <span class="material-symbols-outlined x4">check_circle</span>
          </button>

          {/* success  */}
          {/* <span
            className={`${styles.text_green} pointer pro-d-inline-flex`}
            onClick={() => {
              handleCancel(data?.id);
            }}
          >
            <span class="material-symbols-outlined x4">check_circle</span>
          </span> */}

          {/* error  */}
          {/* <span className={styles.text_red}>
            <span class="material-symbols-outlined x4">
              cancel
            </span>
          </span> */}
        </p>
      ),
    };

    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handleCancel = (id) => {

    setShowDeleteConfirm(true);
    setSelectedItemID(id);
    // dispatch(deleteItemFromTable(id)).then((response) => {
    //   if (response?.payload?.data?.status_code === 200) {
    //     refetch();
    //     toast.success(response?.payload?.data?.message);
    //   } else if (response?.payload?.status_code === 400) {
    //     toast.error(response?.payload?.message);
    //   } else toast.error(response?.payload?.message);
    // });
  }

  return {
    cancelRequestList,
    surrenderDetailsPage,
    cancelRequestPage,
    currentPage: cancelRequestPage.currentPage,
    paginationOptions,
    isFetching,
    isLoading,
    handlePagination,
    handleDateChange,
    handlePageSize,
    handleSort,
    handleSearch,
    getRow,
    handleEditClick,
    closeEditModal,
    showEditModal,
    refetch,
    setIsFilterShow,
    isFilterShow,
    handleDelete,
    showform,
    setShowform,
    showDeleteConfirm,
    setShowDeleteConfirm,
    handleDeleteAction,
    handleEditAction,
    updateCancelRequestFields,
    hasCreatePermission,
    hasViewPermission,
    hasEditPermission,
    
  };
};

export default useCancellationRequestSurrender;
